import React from 'react';
import moment, { Moment } from 'moment';
import { IconButton, InputAdornment, TextFieldVariants } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

import TranslationHelper from '../../../../helpers/TranslationHelper';
import { TMappedAttribute } from '../../types';
import { ATTRIBUTE_TYPES } from '../../constants';

export const getCommonDateTimeProps = (
    attribute: TMappedAttribute,
    label: string,
    error: string,
    setFieldValue: (name: string, v: any) => void
) => {
    const dateTranslations = TranslationHelper.makeDateTimeTranslations();
    const type = ATTRIBUTE_TYPES[attribute.type];

    return {
        ampm: false,
        localeText: dateTranslations,
        value: attribute.value
            ? moment(
                  attribute.value as string,
                  type === 'Time' ? 'HH:mm:ss' : undefined
              )
            : null,
        onChange: (v: Moment | null) => {
            setFieldValue(`attributes.${attribute.name}.value`, v);
        },
        label,
        slotProps: {
            textField: {
                variant: 'standard' as TextFieldVariants,
                error: !!error,
                helperText: error,
                fullWidth: true,
                required: attribute.required,
                InputProps: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setFieldValue(
                                        `attributes.${attribute.name}.value`,
                                        null
                                    );
                                }}
                            >
                                <ClearIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            },
            dialog: {
                disableEnforceFocus: true,
            },
        },
    };
};
